import { defineMessages } from 'react-intl'

const scope = `procurify.purchasing.features.IntercomShareFeedbackButtonPresenter`

export default defineMessages({
  shareFeedback: {
    id: `${scope}.shareFeedback`,
    defaultMessage: 'Share feedback',
  },
})
